import React, { useState } from 'react';
import { IRegistroCircularizacao } from '../interfaces/ICircularizacao';

interface Props {
  registro: IRegistroCircularizacao;
  salvando: boolean;
  onCancelar: () => void;
  onConfirmar: (novaJustificativa: string) => void;
}

// Seção 4.2 — "visualização Empresas Excluídas da Circularização... Permitir: ... Alterar a
// justificativa, quando necessário."
const EditarJustificativaExclusaoModal: React.FC<Props> = ({ registro, salvando, onCancelar, onConfirmar }) => {
  const [justificativa, setJustificativa] = useState(registro.justificativaExclusao ?? '');
  const [tentouEnviar, setTentouEnviar] = useState(false);

  const confirmar = () => {
    setTentouEnviar(true);
    if (justificativa.trim().length === 0) return;
    onConfirmar(justificativa.trim());
  };

  return (
    <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onCancelar()}>
      <div className='circ-modal' style={{ maxWidth: 480 }}>
        <div className='circ-modal-header'>
          <h4>Editar Justificativa da Exclusão</h4>
          <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onCancelar}>
            <i className='bi bi-x-lg' />
          </button>
        </div>
        <div className='circ-modal-body'>
          <p style={{ fontSize: 13 }}>
            <strong>{registro.razaoSocialExibicao}</strong>
          </p>
          <div className='circ-form-group'>
            <label className='circ-campo-obrigatorio'>Justificativa da Exclusão</label>
            <textarea
              className='circ-form-control'
              rows={3}
              value={justificativa}
              onChange={(e) => setJustificativa(e.target.value)}
            />
            {tentouEnviar && justificativa.trim().length === 0 && (
              <div className='text-danger mt-1' style={{ fontSize: 12 }}>A justificativa é obrigatória.</div>
            )}
          </div>
        </div>
        <div className='circ-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={salvando} onClick={onCancelar}>
            Cancelar
          </button>
          <button type='button' className='btn btn-sm btn-primary' disabled={salvando} onClick={confirmar}>
            {salvando && <span className='spinner-border spinner-border-sm me-1' />}
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditarJustificativaExclusaoModal;
